module.exports = __webpack_public_path__ + "img/step-2.5d587b11.png";